// Copyright (c) 2015 Steven Sojka
/* eslint-disable */
import { ApplicateOptions } from '../shared';

export { ApplicateOptions } from '../shared';

export abstract class Applicator {
  abstract apply(options: ApplicateOptions): any;
}
